import { instance } from "../api-instance";

const defaultCatalogs = [
  "Gender",
  "StagePeriod",
  "MaritalStatus",
  "CreditFrequency",
  "Education",
  "OkbPurpOfFinance",
  "IncomeSource",
  "LegalOrganizationalForm",
  "Busyness",
  "CreditorOrganization",
  "CreditType",
  "CreditStatus",
  "CreditDelayGroup",
  "RelationToInsolvent",
  "AddressType",
  "FinancingInstrumentType",
  "ProductType",
  "CashflowSource",
];

export const DictionariesApi = {
  getDictionaries(names: string[] = defaultCatalogs): Promise<unknown> {
    return instance
      .get(`catalog/list`, { params: { names } })
      .then((res) => res.data);
  },
};
